// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--kN7lU","adjustment":"adjustment--d5Q_k"};